<template>
  <div
    class="pl-4 CustomerPickerButton is-flex is-justify-content-space-between is-align-items-center"
    @click="setCustomerPicker(!getCustomerPicker)"
  >
    <div class="cpb-label">
      <span class="label--full">
        {{ getActiveCustomer?.name ? getActiveCustomer.name : $t('customer.select_prompt') }}
      </span>
      <span class="label--short">
        {{ shortCustomerName }}
      </span>
    </div>

    <div class="cpb-chevron is-flex is-align-items-center is-justify-content-center">
      <span class="icon is-info">
        <i :class="getCustomerPicker ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" />
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('appStore', ['getCustomerPicker']),
    ...mapGetters('user', ['getActiveCustomer']),
    shortCustomerName() {
      const n = this.getActiveCustomer?.name?.trim();
      if (!n) return this.$t?.('customer.select_prompt_short') ?? this.$t('customer.select_prompt');
      const words = n.split(/\s+/).filter(Boolean);
      const letters = words.map(w => w[0]).join('').toUpperCase();
      const short = letters.length >= 2 ? letters.slice(0, 6) : n.slice(0, 6).toUpperCase();
      return short;
    }
  },
  methods: {
    ...mapActions('appStore', ['setCustomerPicker'])
  }
};
</script>

<style lang="scss">
.CustomerPickerButton {
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  text-align: left;
  cursor: pointer;
  border: 0;
  color: #ef7c21;
  background-color: #363a41;
  position: relative;
  transition: background-color 0.3s ease;

  container-type: inline-size;

  &:hover {
    transition: background-color 0.3s ease;
    background-color: #4b5158;
  }

  @media (min-width: 769px) {
    max-width: 300px; 
  }
}


.cpb-label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  .label--full { display: inline; }
  .label--short { display: none; }
}

@container (max-width: 160px) {
  .cpb-label {
    .label--full { display: none; }
    .label--short { display: inline; }
  }
}

.cpb-chevron {
  height: 100%;
  width: 48px;
  flex: 0 0 48px;
  min-width: 48px;
}
</style>
